import { render, staticRenderFns } from "./NoteDetailsTopPanel.vue?vue&type=template&id=54f31fa8&scoped=true&"
import script from "./NoteDetailsTopPanel.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsTopPanel.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsTopPanel.vue?vue&type=style&index=0&id=54f31fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f31fa8",
  null
  
)

export default component.exports